import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';
import PhoneInput from 'react-phone-input-2';
import { useLocation, useNavigate } from 'react-router-dom';
import BottomPopup from './BottomPopup';
import giftToggle from '../store/actions/giftToggle';
import giftServices from '../utils/giftServices';
import Snowfall from './Snowfall';
import Api from '../api';
import Spinner from './Spinner';

function GiftCartForm() {
  const { t } = useTranslation();
  const [recipientPhone, setRecipientPhone] = useState('');
  const [senderPhone, setSenderPhone] = useState('');
  const [recipientEmail, setRecipientEmail] = useState('');
  const [recipientPhoneError, setRecipientPhoneError] = useState('');
  const [senderPhoneError, setSenderPhoneError] = useState('');
  const [recipientEmailError, setRecipientEmailError] = useState('');
  const [recipientName, setRecipientName] = useState('');
  const [senderName, setSenderName] = useState('');
  const [recipientNameError, setRecipientNameError] = useState('');
  const [senderNameError, setSenderNameError] = useState('');
  const [btnLoading, setBtnLoading] = useState(false);
  const lang = Cookies.get('i18next') || 'en';
  const dispatch = useDispatch();
  const { visible } = useSelector((state) => state.giftToggle);
  const navigate = useNavigate();
  const location = useLocation();
  if (!visible) return null;
  const handleCloseModal = () => {
    dispatch(giftToggle(false));
    const params = new URLSearchParams(location.search);
    params.delete('gift');

    navigate(`${location.pathname}?${params.toString()}`, {
      replace: true,
    });
  };
  const handleSubmit = async () => {
    try {
      setBtnLoading(true);
      const { data } = await Api.sendGiftCart({
        receiver_name: recipientName,
        receiver_phone: recipientPhone,
        receiver_email: recipientEmail,
        sender_name: senderName,
        sender_phone: senderPhone,
        lang,
      });
      window.location.replace(data.data);
    } catch (e) {
      const { errors } = e.response.data;
      if (errors) {
        if (errors.receiver_name) {
          setRecipientNameError(errors.receiver_name[0]);
        }
        if (errors.receiver_phone) {
          setRecipientPhoneError(errors.receiver_phone[0]);
        }
        if (errors.receiver_email) {
          setRecipientEmailError(errors.receiver_email[0]);
        }
        if (errors.sender_name) {
          setSenderNameError(errors.sender_name[0]);
        }
        if (errors.sender_phone) {
          setSenderPhoneError(errors.sender_phone[0]);
        }
      }
      console.log(errors);
      setBtnLoading(false);
    } finally {
      setBtnLoading(false);
    }
  };
  const handleChangePhone = (value) => {
    setRecipientPhone(value);
    setRecipientPhoneError('');
  };
  const handleChangePhone2 = (value) => {
    setSenderPhone(value);
    setSenderPhoneError('');
  };
  return (
    <>
      <Snowfall active={visible} />
      <BottomPopup
        footer={() => (
          <div className="modal-popup-actions gift-modal-footer">
            <button
              type="button"
              onClick={handleCloseModal}
              className="modal-popup-actions-button"
            >
              {t('buttons.cancel')}
            </button>
            <button
              disabled={btnLoading}
              onClick={handleSubmit}
              type="submit"
              className="modal-popup-actions-button confirm"
            >
              {btnLoading ? <Spinner isBtn size={20} /> : t('buttons.buy_gift')}
            </button>
          </div>
        )}
        header={t('gift.title')}
        handleCloseModal={handleCloseModal}
        visible={visible}
      >
        <div className="gift-form-top">
          <h2>{t('gift.title2')}</h2>
          <ul className="gift-services">
            {giftServices.map((service) => (
              <li key={service.id}>
                <p>{service[`title_${lang}`]}</p>
              </li>
            ))}
          </ul>
          <hr />
          <div className="gift-form-bottom">
            <p>{t('gift.title3')}</p>
            <p>20.000 AMD</p>
          </div>
        </div>
        <form action="#" onSubmit={handleSubmit} className="modal-form gift-form">
          <div className="modal-form-top">
            <p>{t('gift.title4')}</p>
            <div className="modal-input-container">
              <div className="modal-input-block">
                <label
                  htmlFor="recipinet_fullName"
                  className="modal-input-block-label"
                >
                  {t('gift.recipient_name')}
                </label>
                <input
                  value={recipientName}
                  placeholder={t('placeholder.recipient_name')}
                  type="text"
                  id="recipinet_fullName"
                  onChange={(e) => {
                    setRecipientName(e.target.value);
                    setRecipientNameError('');
                  }}
                  className="modal-input-block-input checkout"
                />
              </div>
              {recipientNameError && <p className="authError">{recipientNameError}</p>}
            </div>
            <div className="modal-input-container">
              <div className="modal-input-block">
                <label htmlFor="recipinet_phone" className="modal-input-block-label">
                  {t('gift.recipient_phone')}
                </label>
                <PhoneInput
                  id="recipinet_phone"
                  country="am"
                  placeholder="XX XXX XXXX"
                  value={recipientPhone}
                  onChange={handleChangePhone}
                  containerClass="phone-input-container"
                  inputClass="phone-input"
                  buttonClass="phone-input-button"
                  dropdownClass="phone-input-dropdown"
                />
                {recipientPhoneError && <p className="authError">{recipientPhoneError}</p>}
              </div>
            </div>
            <div className="modal-input-container">
              <div className="modal-input-block">
                <label
                  htmlFor="recipinet_email"
                  className="modal-input-block-label"
                >
                  {t('gift.recipient_email')}
                </label>
                <input
                  value={recipientEmail}
                  placeholder="example@mail.com"
                  type="email"
                  id="recipinet_email"
                  onChange={(e) => {
                    setRecipientEmail(e.target.value);
                    setRecipientEmailError('');
                  }}
                  className="modal-input-block-input checkout"
                />
              </div>
              {recipientEmailError && <p className="authError">{recipientEmailError}</p>}
            </div>
          </div>
          <div className="modal-form-bottom">
            <p>{t('gift.title5')}</p>
            <p className="gift-text">
              {t('gift.text')}
              {' '}
              <strong>{t('gift.text2')}</strong>
              {' '}
            </p>
            <div className="modal-input-container">
              <div className="modal-input-block">
                <label
                  htmlFor="sender_fullName"
                  className="modal-input-block-label"
                >
                  {t('gift.sender_name')}
                </label>
                <input
                  value={senderName}
                  placeholder={t('placeholder.sender_name')}
                  type="text"
                  id="sender_fullName"
                  onChange={(e) => {
                    setSenderName(e.target.value);
                    setSenderNameError('');
                  }}
                  className="modal-input-block-input checkout"
                />
              </div>
              {senderNameError && <p className="authError">{senderNameError}</p>}
            </div>
            <div className="modal-input-container">
              <div className="modal-input-block">
                <label htmlFor="sender_phone" className="modal-input-block-label">
                  {t('gift.sender_phone')}
                </label>
                <PhoneInput
                  id="sender_phone"
                  country="am"
                  placeholder="XX XXX XXXX"
                  value={senderPhone}
                  onChange={handleChangePhone2}
                  containerClass="phone-input-container"
                  inputClass="phone-input"
                  buttonClass="phone-input-button"
                  dropdownClass="phone-input-dropdown"
                />
                {senderPhoneError && <p className="authError">{senderPhoneError}</p>}
              </div>
            </div>
          </div>
        </form>
      </BottomPopup>
    </>
  );
}

export default GiftCartForm;
